import { Controller } from "@hotwired/stimulus"
import { DomHelper } from "../utils/dom"

export default class extends Controller {
  static targets = ["zipcode", "prefecture", "address"]

  async lookup() {
    const zipcode = this.zipcodeTarget.value.replace(/[^0-9]/g, '')

    DomHelper.clearValidation(this.zipcodeTarget)

    if (zipcode.length === 0) {
      return
    }

    if (zipcode.length !== 7) {
      this.showError()
      return
    }

    DomHelper.showValidationSuccess(this.zipcodeTarget)

    try {
      const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zipcode}`)
      const data = await response.json()

      if (data.status === 200 && data.results && data.results.length > 0) {
        const result = data.results[0]
        this.prefectureTarget.value = result.address1
        this.addressTarget.value = result.address2 + result.address3
        this.addressTarget.focus()
      } else {
        this.showError()
      }
    } catch (error) {
      console.error('Postal code lookup error:', error)
      this.showError()
    }
  }

  showError() {
    DomHelper.showValidationError(this.zipcodeTarget)
  }
}
